var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShinroInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1415_603)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 0C18.6569 0 20 1.34315 20 3V21C20 22.6569 18.6569 24 17 24H3C1.34315 24 0 22.6569 0 21V3C2.04994e-08 1.34315 1.34315 0 3 0H17ZM3 2C2.44772 2 2 2.44772 2 3V21C2 21.5523 2.44771 22 3 22H17C17.5523 22 18 21.5523 18 21V3C18 2.44772 17.5523 2 17 2H3ZM11.5 16.5C12.0523 16.5 12.5 16.9477 12.5 17.5C12.5 18.0523 12.0523 18.5 11.5 18.5H5.5C4.94772 18.5 4.5 18.0523 4.5 17.5C4.5 16.9477 4.94772 16.5 5.5 16.5H11.5ZM14.5 12.5C15.0523 12.5 15.5 12.9477 15.5 13.5C15.5 14.0523 15.0523 14.5 14.5 14.5H5.5C4.94772 14.5 4.5 14.0523 4.5 13.5C4.5 12.9477 4.94772 12.5 5.5 12.5H14.5ZM13.5 4.5C14.6046 4.5 15.5 5.39543 15.5 6.5V8.5C15.5 9.60457 14.6046 10.5 13.5 10.5H6.5C5.39543 10.5 4.5 9.60457 4.5 8.5V6.5C4.5 5.39543 5.39543 4.5 6.5 4.5H13.5ZM6.5 8.5H13.5V6.5H6.5V8.5Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1415_603"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 24,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShinroInformation);
export default __webpack_public_path__ + "static/media/shinro-information.3b028df9b97e9de0fcfaec5638ffa810.svg";
export { ForwardRef as ReactComponent };